<script setup lang="ts">
import {SupportProgramSettings} from "@/program/interfaces/Program";
import {Label} from "@/core/components/ui/label";
import {Checkbox} from "@/core/components/ui/checkbox";
import {computed} from "vue";
import SupportProgramSettingsService from "@/program/services/SupportProgramSettingsService";

const props = defineProps<{
    settings: SupportProgramSettings,
}>();

const emit = defineEmits(['update']);

/**
 * Update handler for the checkbox.
 * @param slug  The slug of the group.
 * @param checked The checked state of the checkbox.
 */
const onUpdate = (slug: string, checked: boolean) => {
    emit('update', slug, checked);
};

/**
 * Compute the included groups, filtering user_inclusion.
 */
const includeGroups = computed(() => {
    return Object.entries(props.settings.meta.included).filter(value => value[0] !== 'user_inclusion');
});
</script>

<template>
  <div class="flex flex-col gap-1 border-y border-t-gray-100 py-3">
    <div class="flex items-center">
      <Label class="font-bold pt-1 w-24">Ciblage :</Label>
      <div class="flex flex-1 gap-x-4 items-center flex-wrap">
        <div
          v-for="[slug, label] in includeGroups" :key="slug"
          class="flex items-center gap-1"
        >
          <Checkbox
            :id="slug"
            :model-value="SupportProgramSettingsService.isInclusionGroupEnabled(settings, slug)"
            @update:model-value="(checked) => onUpdate(slug, !!checked)"
          />
          <Label :for="slug" class="cursor-pointer pt-1">{{ label }}</Label>
        </div>
      </div>
    </div>
    <div class="flex items-center">
      <Label class="w-24 font-bold pt-1">Statut :</Label>
      <div class="flex flex-1 gap-4 items-center flex-wrap">
        <div
          v-for="[slug, label] in Object.entries(settings.meta.excluded)" :key="slug"
          class="flex items-center gap-1"
        >
          <Checkbox
            :id="slug"
            :model-value="SupportProgramSettingsService.isExclusionGroupEnabled(settings, slug)"
            @update:model-value="(checked) => onUpdate(slug, !!checked)"
          />
          <Label :for="slug" class="cursor-pointer pt-1">{{ label }}</Label>
        </div>
      </div>
    </div>
  </div>
</template>
